<!-- 管网检查 -->
<template>
  <a-card :bordered="false">
    <iframe src="http://116.130.185.160:18081/pipe/check" scrolling="auto" frameborder="0" style="width: 100%;height: 100vh;"></iframe>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import {
    httpAction,
    getAction,
    postAction
  } from '@/api/manage'
  import {
    filterDictTextByCache
  } from '@/components/dict/JDictSelectUtil';

  export default {
    name: 'PipelineGIS',
    components: {},
    data () {
      return {}
    },
    created() {},
    computed: {},
    watch:{},
    methods: {}
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>